export default {
    "total": [{
        "value": "13916641",
        "name": "北京"
    }, {
        "value": "33963711",
        "name": "天津"
    }, {
        "value": "53555825",
        "name": "河北"
    }, {
        "value": "33101614",
        "name": "山西"
    }, {
        "value": "42974487",
        "name": "河南"
    }, {
        "value": "54304424",
        "name": "山东"
    }, {
        "value": "15386599",
        "name": "上海"
    }, {
        "value": "63215643",
        "name": "江苏"
    }, {
        "value": "43423345",
        "name": "浙江"
    }, {
        "value": "12465151",
        "name": "福建"
    }, {
        "value": "33279671",
        "name": "安徽"
    }, {
        "value": "21601712",
        "name": "江西"
    }, {
        "value": "28915097",
        "name": "湖北"
    }, {
        "value": "28468840",
        "name": "湖南"
    }, {
        "value": "45204368",
        "name": "广东"
    }, {
        "value": "10920586",
        "name": "广西"
    }, {
        "value": "14727961",
        "name": "贵州"
    }, {
        "value": "9895868",
        "name": "云南"
    }, {
        "value": "1665996",
        "name": "海南"
    }, {
        "value": "3492246",
        "name": "黑龙江"
    }, {
        "value": "9289223",
        "name": "吉林"
    }, {
        "value": "12645866",
        "name": "辽宁"
    }, {
        "value": "32368669",
        "name": "陕西"
    }, {
        "value": "8814742",
        "name": "新疆"
    }, {
        "value": "24851546",
        "name": "内蒙古"
    }, {
        "value": "3348306",
        "name": "青海"
    }, {
        "value": "6817943",
        "name": "宁夏"
    }, {
        "value": "12127001",
        "name": "甘肃"
    }, {
        "value": "1280126",
        "name": "西藏"
    }, {
        "value": "18055760",
        "name": "四川"
    }, {
        "value": "12122918",
        "name": "重庆"
    }],
    "list": [{
        "item": [{
            "value": "-1",
            "name": "北京"
        }, {
            "value": "2431159",
            "name": "天津"
        }, {
            "value": "5026149",
            "name": "河北"
        }, {
            "value": "199925",
            "name": "山西"
        }, {
            "value": "746653",
            "name": "河南"
        }, {
            "value": "745923",
            "name": "山东"
        }, {
            "value": "121657",
            "name": "上海"
        }, {
            "value": "392030",
            "name": "江苏"
        }, {
            "value": "149202",
            "name": "浙江"
        }, {
            "value": "59661",
            "name": "福建"
        }, {
            "value": "181827",
            "name": "安徽"
        }, {
            "value": "155177",
            "name": "江西"
        }, {
            "value": "301605",
            "name": "湖北"
        }, {
            "value": "226313",
            "name": "湖南"
        }, {
            "value": "234799",
            "name": "广东"
        }, {
            "value": "38986",
            "name": "广西"
        }, {
            "value": "61334",
            "name": "贵州"
        }, {
            "value": "25962",
            "name": "云南"
        }, {
            "value": "6407",
            "name": "海南"
        }, {
            "value": "36245",
            "name": "黑龙江"
        }, {
            "value": "74756",
            "name": "吉林"
        }, {
            "value": "326933",
            "name": "辽宁"
        }, {
            "value": "169512",
            "name": "陕西"
        }, {
            "value": "20430",
            "name": "新疆"
        }, {
            "value": "249495",
            "name": "内蒙古"
        }, {
            "value": "6019",
            "name": "青海"
        }, {
            "value": "28615",
            "name": "宁夏"
        }, {
            "value": "39827",
            "name": "甘肃"
        }, {
            "value": "2045",
            "name": "西藏"
        }, {
            "value": "101334",
            "name": "四川"
        }, {
            "value": "73193",
            "name": "重庆"
        }],
        "nameName": "北京",
        "toatl": "12233172"
    }, {
        "item": [{
            "value": "1222408",
            "name": "北京"
        }, {
            "value": "-1",
            "name": "天津"
        }, {
            "value": "4305929",
            "name": "河北"
        }, {
            "value": "320500",
            "name": "山西"
        }, {
            "value": "429033",
            "name": "河南"
        }, {
            "value": "721110",
            "name": "山东"
        }, {
            "value": "96124",
            "name": "上海"
        }, {
            "value": "406053",
            "name": "江苏"
        }, {
            "value": "124853",
            "name": "浙江"
        }, {
            "value": "27854",
            "name": "福建"
        }, {
            "value": "124359",
            "name": "安徽"
        }, {
            "value": "67511",
            "name": "江西"
        }, {
            "value": "151484",
            "name": "湖北"
        }, {
            "value": "111651",
            "name": "湖南"
        }, {
            "value": "148683",
            "name": "广东"
        }, {
            "value": "23416",
            "name": "广西"
        }, {
            "value": "20325",
            "name": "贵州"
        }, {
            "value": "16928",
            "name": "云南"
        }, {
            "value": "3900",
            "name": "海南"
        }, {
            "value": "22661",
            "name": "黑龙江"
        }, {
            "value": "71099",
            "name": "吉林"
        }, {
            "value": "237331",
            "name": "辽宁"
        }, {
            "value": "161128",
            "name": "陕西"
        }, {
            "value": "85850",
            "name": "新疆"
        }, {
            "value": "965809",
            "name": "内蒙古"
        }, {
            "value": "13469",
            "name": "青海"
        }, {
            "value": "88651",
            "name": "宁夏"
        }, {
            "value": "51443",
            "name": "甘肃"
        }, {
            "value": "3771",
            "name": "西藏"
        }, {
            "value": "64216",
            "name": "四川"
        }, {
            "value": "40819",
            "name": "重庆"
        }],
        "nameName": "天津",
        "toatl": "10128367"
    }, {
        "item": [{
            "value": "7117842",
            "name": "北京"
        }, {
            "value": "16253056",
            "name": "天津"
        }, {
            "value": "-1",
            "name": "河北"
        }, {
            "value": "18822641",
            "name": "山西"
        }, {
            "value": "11832267",
            "name": "河南"
        }, {
            "value": "24791853",
            "name": "山东"
        }, {
            "value": "583689",
            "name": "上海"
        }, {
            "value": "5808830",
            "name": "江苏"
        }, {
            "value": "1493685",
            "name": "浙江"
        }, {
            "value": "387325",
            "name": "福建"
        }, {
            "value": "2192200",
            "name": "安徽"
        }, {
            "value": "1133872",
            "name": "江西"
        }, {
            "value": "2800495",
            "name": "湖北"
        }, {
            "value": "2534009",
            "name": "湖南"
        }, {
            "value": "1653399",
            "name": "广东"
        }, {
            "value": "660446",
            "name": "广西"
        }, {
            "value": "660930",
            "name": "贵州"
        }, {
            "value": "660911",
            "name": "云南"
        }, {
            "value": "86729",
            "name": "海南"
        }, {
            "value": "353578",
            "name": "黑龙江"
        }, {
            "value": "619315",
            "name": "吉林"
        }, {
            "value": "2091163",
            "name": "辽宁"
        }, {
            "value": "5818276",
            "name": "陕西"
        }, {
            "value": "1865707",
            "name": "新疆"
        }, {
            "value": "6687337",
            "name": "内蒙古"
        }, {
            "value": "591998",
            "name": "青海"
        }, {
            "value": "1279068",
            "name": "宁夏"
        }, {
            "value": "1428158",
            "name": "甘肃"
        }, {
            "value": "131187",
            "name": "西藏"
        }, {
            "value": "1507817",
            "name": "四川"
        }, {
            "value": "524728",
            "name": "重庆"
        }],
        "nameName": "河北",
        "toatl": "122372510"
    }, {
        "item": [{
            "value": "1040742",
            "name": "北京"
        }, {
            "value": "2600588",
            "name": "天津"
        }, {
            "value": "10105190",
            "name": "河北"
        }, {
            "value": "-1",
            "name": "山西"
        }, {
            "value": "5229744",
            "name": "河南"
        }, {
            "value": "1891628",
            "name": "山东"
        }, {
            "value": "75415",
            "name": "上海"
        }, {
            "value": "579761",
            "name": "江苏"
        }, {
            "value": "233500",
            "name": "浙江"
        }, {
            "value": "142581",
            "name": "福建"
        }, {
            "value": "429460",
            "name": "安徽"
        }, {
            "value": "306346",
            "name": "江西"
        }, {
            "value": "1090773",
            "name": "湖北"
        }, {
            "value": "893922",
            "name": "湖南"
        }, {
            "value": "770234",
            "name": "广东"
        }, {
            "value": "450869",
            "name": "广西"
        }, {
            "value": "453709",
            "name": "贵州"
        }, {
            "value": "307152",
            "name": "云南"
        }, {
            "value": "39027",
            "name": "海南"
        }, {
            "value": "48572",
            "name": "黑龙江"
        }, {
            "value": "46153",
            "name": "吉林"
        }, {
            "value": "114271",
            "name": "辽宁"
        }, {
            "value": "8750562",
            "name": "陕西"
        }, {
            "value": "407768",
            "name": "新疆"
        }, {
            "value": "4894965",
            "name": "内蒙古"
        }, {
            "value": "258763",
            "name": "青海"
        }, {
            "value": "753122",
            "name": "宁夏"
        }, {
            "value": "784215",
            "name": "甘肃"
        }, {
            "value": "22475",
            "name": "西藏"
        }, {
            "value": "1086683",
            "name": "四川"
        }, {
            "value": "601561",
            "name": "重庆"
        }],
        "nameName": "山西",
        "toatl": "44409750"
    }, {
        "item": [{
            "value": "507517",
            "name": "北京"
        }, {
            "value": "902849",
            "name": "天津"
        }, {
            "value": "4604553",
            "name": "河北"
        }, {
            "value": "5378467",
            "name": "山西"
        }, {
            "value": "-1",
            "name": "河南"
        }, {
            "value": "5856989",
            "name": "山东"
        }, {
            "value": "1415274",
            "name": "上海"
        }, {
            "value": "4955345",
            "name": "江苏"
        }, {
            "value": "4325186",
            "name": "浙江"
        }, {
            "value": "1580506",
            "name": "福建"
        }, {
            "value": "6795353",
            "name": "安徽"
        }, {
            "value": "2610810",
            "name": "江西"
        }, {
            "value": "8452093",
            "name": "湖北"
        }, {
            "value": "5122134",
            "name": "湖南"
        }, {
            "value": "4941151",
            "name": "广东"
        }, {
            "value": "1645131",
            "name": "广西"
        }, {
            "value": "1156370",
            "name": "贵州"
        }, {
            "value": "1119060",
            "name": "云南"
        }, {
            "value": "242137",
            "name": "海南"
        }, {
            "value": "37850",
            "name": "黑龙江"
        }, {
            "value": "52878",
            "name": "吉林"
        }, {
            "value": "200029",
            "name": "辽宁"
        }, {
            "value": "6435877",
            "name": "陕西"
        }, {
            "value": "1769135",
            "name": "新疆"
        }, {
            "value": "635562",
            "name": "内蒙古"
        }, {
            "value": "558356",
            "name": "青海"
        }, {
            "value": "953881",
            "name": "宁夏"
        }, {
            "value": "2230119",
            "name": "甘肃"
        }, {
            "value": "190920",
            "name": "西藏"
        }, {
            "value": "1767622",
            "name": "四川"
        }, {
            "value": "1130647",
            "name": "重庆"
        }],
        "nameName": "河南",
        "toatl": "77573800"
    }, {
        "item": [{
            "value": "911356",
            "name": "北京"
        }, {
            "value": "2571976",
            "name": "天津"
        }, {
            "value": "9730322",
            "name": "河北"
        }, {
            "value": "3901027",
            "name": "山西"
        }, {
            "value": "8440628",
            "name": "河南"
        }, {
            "value": "-1",
            "name": "山东"
        }, {
            "value": "1565030",
            "name": "上海"
        }, {
            "value": "16957130",
            "name": "江苏"
        }, {
            "value": "3645000",
            "name": "浙江"
        }, {
            "value": "921049",
            "name": "福建"
        }, {
            "value": "6626528",
            "name": "安徽"
        }, {
            "value": "2569440",
            "name": "江西"
        }, {
            "value": "2778654",
            "name": "湖北"
        }, {
            "value": "2228223",
            "name": "湖南"
        }, {
            "value": "2140963",
            "name": "广东"
        }, {
            "value": "1020649",
            "name": "广西"
        }, {
            "value": "780510",
            "name": "贵州"
        }, {
            "value": "747182",
            "name": "云南"
        }, {
            "value": "147263",
            "name": "海南"
        }, {
            "value": "168128",
            "name": "黑龙江"
        }, {
            "value": "301374",
            "name": "吉林"
        }, {
            "value": "941548",
            "name": "辽宁"
        }, {
            "value": "3118737",
            "name": "陕西"
        }, {
            "value": "1371879",
            "name": "新疆"
        }, {
            "value": "1055753",
            "name": "内蒙古"
        }, {
            "value": "367844",
            "name": "青海"
        }, {
            "value": "650751",
            "name": "宁夏"
        }, {
            "value": "1063121",
            "name": "甘肃"
        }, {
            "value": "69544",
            "name": "西藏"
        }, {
            "value": "1316005",
            "name": "四川"
        }, {
            "value": "607274",
            "name": "重庆"
        }],
        "nameName": "山东",
        "toatl": "78714887"
    }, {
        "item": [{
            "value": "217565",
            "name": "北京"
        }, {
            "value": "507402",
            "name": "天津"
        }, {
            "value": "682592",
            "name": "河北"
        }, {
            "value": "108450",
            "name": "山西"
        }, {
            "value": "991749",
            "name": "河南"
        }, {
            "value": "1249476",
            "name": "山东"
        }, {
            "value": "-1",
            "name": "上海"
        }, {
            "value": "13245217",
            "name": "江苏"
        }, {
            "value": "8438888",
            "name": "浙江"
        }, {
            "value": "555853",
            "name": "福建"
        }, {
            "value": "2197435",
            "name": "安徽"
        }, {
            "value": "1313975",
            "name": "江西"
        }, {
            "value": "1176185",
            "name": "湖北"
        }, {
            "value": "685486",
            "name": "湖南"
        }, {
            "value": "1327164",
            "name": "广东"
        }, {
            "value": "196965",
            "name": "广西"
        }, {
            "value": "207269",
            "name": "贵州"
        }, {
            "value": "116325",
            "name": "云南"
        }, {
            "value": "20017",
            "name": "海南"
        }, {
            "value": "51473",
            "name": "黑龙江"
        }, {
            "value": "103913",
            "name": "吉林"
        }, {
            "value": "360044",
            "name": "辽宁"
        }, {
            "value": "343195",
            "name": "陕西"
        }, {
            "value": "56158",
            "name": "新疆"
        }, {
            "value": "44507",
            "name": "内蒙古"
        }, {
            "value": "7968",
            "name": "青海"
        }, {
            "value": "38782",
            "name": "宁夏"
        }, {
            "value": "91768",
            "name": "甘肃"
        }, {
            "value": "979",
            "name": "西藏"
        }, {
            "value": "444465",
            "name": "四川"
        }, {
            "value": "654400",
            "name": "重庆"
        }],
        "nameName": "上海",
        "toatl": "35435664"
    }, {
        "item": [{
            "value": "228243",
            "name": "北京"
        }, {
            "value": "618614",
            "name": "天津"
        }, {
            "value": "1235897",
            "name": "河北"
        }, {
            "value": "400935",
            "name": "山西"
        }, {
            "value": "2037784",
            "name": "河南"
        }, {
            "value": "7669279",
            "name": "山东"
        }, {
            "value": "4804970",
            "name": "上海"
        }, {
            "value": "-1",
            "name": "江苏"
        }, {
            "value": "6405596",
            "name": "浙江"
        }, {
            "value": "761452",
            "name": "福建"
        }, {
            "value": "9203804",
            "name": "安徽"
        }, {
            "value": "2072294",
            "name": "江西"
        }, {
            "value": "1628090",
            "name": "湖北"
        }, {
            "value": "1046362",
            "name": "湖南"
        }, {
            "value": "1206810",
            "name": "广东"
        }, {
            "value": "338845",
            "name": "广西"
        }, {
            "value": "389648",
            "name": "贵州"
        }, {
            "value": "274216",
            "name": "云南"
        }, {
            "value": "61933",
            "name": "海南"
        }, {
            "value": "38175",
            "name": "黑龙江"
        }, {
            "value": "55756",
            "name": "吉林"
        }, {
            "value": "193730",
            "name": "辽宁"
        }, {
            "value": "658714",
            "name": "陕西"
        }, {
            "value": "187969",
            "name": "新疆"
        }, {
            "value": "185851",
            "name": "内蒙古"
        }, {
            "value": "69110",
            "name": "青海"
        }, {
            "value": "158970",
            "name": "宁夏"
        }, {
            "value": "261044",
            "name": "甘肃"
        }, {
            "value": "20228",
            "name": "西藏"
        }, {
            "value": "412998",
            "name": "四川"
        }, {
            "value": "496659",
            "name": "重庆"
        }],
        "nameName": "江苏",
        "toatl": "43123975"
    }, {
        "item": [{
            "value": "74504",
            "name": "北京"
        }, {
            "value": "250631",
            "name": "天津"
        }, {
            "value": "486381",
            "name": "河北"
        }, {
            "value": "107300",
            "name": "山西"
        }, {
            "value": "707464",
            "name": "河南"
        }, {
            "value": "792480",
            "name": "山东"
        }, {
            "value": "2333041",
            "name": "上海"
        }, {
            "value": "3502112",
            "name": "江苏"
        }, {
            "value": "-1",
            "name": "浙江"
        }, {
            "value": "897620",
            "name": "福建"
        }, {
            "value": "1613511",
            "name": "安徽"
        }, {
            "value": "1966672",
            "name": "江西"
        }, {
            "value": "811280",
            "name": "湖北"
        }, {
            "value": "704029",
            "name": "湖南"
        }, {
            "value": "1481191",
            "name": "广东"
        }, {
            "value": "229330",
            "name": "广西"
        }, {
            "value": "257206",
            "name": "贵州"
        }, {
            "value": "138111",
            "name": "云南"
        }, {
            "value": "12170",
            "name": "海南"
        }, {
            "value": "38463",
            "name": "黑龙江"
        }, {
            "value": "82612",
            "name": "吉林"
        }, {
            "value": "274661",
            "name": "辽宁"
        }, {
            "value": "209133",
            "name": "陕西"
        }, {
            "value": "35543",
            "name": "新疆"
        }, {
            "value": "18178",
            "name": "内蒙古"
        }, {
            "value": "5510",
            "name": "青海"
        }, {
            "value": "27413",
            "name": "宁夏"
        }, {
            "value": "71166",
            "name": "甘肃"
        }, {
            "value": "853",
            "name": "西藏"
        }, {
            "value": "275512",
            "name": "四川"
        }, {
            "value": "390459",
            "name": "重庆"
        }],
        "nameName": "浙江",
        "toatl": "17794535"
    }, {
        "item": [{
            "value": "18826",
            "name": "北京"
        }, {
            "value": "38281",
            "name": "天津"
        }, {
            "value": "67872",
            "name": "河北"
        }, {
            "value": "10156",
            "name": "山西"
        }, {
            "value": "84780",
            "name": "河南"
        }, {
            "value": "162531",
            "name": "山东"
        }, {
            "value": "129906",
            "name": "上海"
        }, {
            "value": "230198",
            "name": "江苏"
        }, {
            "value": "787691",
            "name": "浙江"
        }, {
            "value": "-1",
            "name": "福建"
        }, {
            "value": "172672",
            "name": "安徽"
        }, {
            "value": "432490",
            "name": "江西"
        }, {
            "value": "115776",
            "name": "湖北"
        }, {
            "value": "134465",
            "name": "湖南"
        }, {
            "value": "1728434",
            "name": "广东"
        }, {
            "value": "69428",
            "name": "广西"
        }, {
            "value": "36392",
            "name": "贵州"
        }, {
            "value": "24853",
            "name": "云南"
        }, {
            "value": "2918",
            "name": "海南"
        }, {
            "value": "1035",
            "name": "黑龙江"
        }, {
            "value": "3381",
            "name": "吉林"
        }, {
            "value": "22440",
            "name": "辽宁"
        }, {
            "value": "20564",
            "name": "陕西"
        }, {
            "value": "9050",
            "name": "新疆"
        }, {
            "value": "5080",
            "name": "内蒙古"
        }, {
            "value": "566",
            "name": "青海"
        }, {
            "value": "1761",
            "name": "宁夏"
        }, {
            "value": "6861",
            "name": "甘肃"
        }, {
            "value": "127",
            "name": "西藏"
        }, {
            "value": "34982",
            "name": "四川"
        }, {
            "value": "95108",
            "name": "重庆"
        }],
        "nameName": "福建",
        "toatl": "4448623"
    }, {
        "item": [{
            "value": "174247",
            "name": "北京"
        }, {
            "value": "316677",
            "name": "天津"
        }, {
            "value": "717038",
            "name": "河北"
        }, {
            "value": "237462",
            "name": "山西"
        }, {
            "value": "4437543",
            "name": "河南"
        }, {
            "value": "2334323",
            "name": "山东"
        }, {
            "value": "2659043",
            "name": "上海"
        }, {
            "value": "11638233",
            "name": "江苏"
        }, {
            "value": "11318690",
            "name": "浙江"
        }, {
            "value": "1806953",
            "name": "福建"
        }, {
            "value": "-1",
            "name": "安徽"
        }, {
            "value": "4485530",
            "name": "江西"
        }, {
            "value": "2795747",
            "name": "湖北"
        }, {
            "value": "1753939",
            "name": "湖南"
        }, {
            "value": "3981087",
            "name": "广东"
        }, {
            "value": "730385",
            "name": "广西"
        }, {
            "value": "539343",
            "name": "贵州"
        }, {
            "value": "462416",
            "name": "云南"
        }, {
            "value": "157514",
            "name": "海南"
        }, {
            "value": "22180",
            "name": "黑龙江"
        }, {
            "value": "42535",
            "name": "吉林"
        }, {
            "value": "130322",
            "name": "辽宁"
        }, {
            "value": "947852",
            "name": "陕西"
        }, {
            "value": "388853",
            "name": "新疆"
        }, {
            "value": "117645",
            "name": "内蒙古"
        }, {
            "value": "118848",
            "name": "青海"
        }, {
            "value": "133841",
            "name": "宁夏"
        }, {
            "value": "398997",
            "name": "甘肃"
        }, {
            "value": "18918",
            "name": "西藏"
        }, {
            "value": "830799",
            "name": "四川"
        }, {
            "value": "877147",
            "name": "重庆"
        }],
        "nameName": "安徽",
        "toatl": "54574106"
    }, {
        "item": [{
            "value": "63520",
            "name": "北京"
        }, {
            "value": "91793",
            "name": "天津"
        }, {
            "value": "211451",
            "name": "河北"
        }, {
            "value": "52378",
            "name": "山西"
        }, {
            "value": "451218",
            "name": "河南"
        }, {
            "value": "273876",
            "name": "山东"
        }, {
            "value": "453103",
            "name": "上海"
        }, {
            "value": "911158",
            "name": "江苏"
        }, {
            "value": "3253507",
            "name": "浙江"
        }, {
            "value": "2813506",
            "name": "福建"
        }, {
            "value": "901575",
            "name": "安徽"
        }, {
            "value": "-1",
            "name": "江西"
        }, {
            "value": "1346637",
            "name": "湖北"
        }, {
            "value": "3727299",
            "name": "湖南"
        }, {
            "value": "9447635",
            "name": "广东"
        }, {
            "value": "1236800",
            "name": "广西"
        }, {
            "value": "880232",
            "name": "贵州"
        }, {
            "value": "574680",
            "name": "云南"
        }, {
            "value": "357171",
            "name": "海南"
        }, {
            "value": "22336",
            "name": "黑龙江"
        }, {
            "value": "36255",
            "name": "吉林"
        }, {
            "value": "53873",
            "name": "辽宁"
        }, {
            "value": "218464",
            "name": "陕西"
        }, {
            "value": "90339",
            "name": "新疆"
        }, {
            "value": "48262",
            "name": "内蒙古"
        }, {
            "value": "118692",
            "name": "青海"
        }, {
            "value": "60838",
            "name": "宁夏"
        }, {
            "value": "205542",
            "name": "甘肃"
        }, {
            "value": "48805",
            "name": "西藏"
        }, {
            "value": "363344",
            "name": "四川"
        }, {
            "value": "438013",
            "name": "重庆"
        }],
        "nameName": "江西",
        "toatl": "28752301"
    }, {
        "item": [{
            "value": "43117",
            "name": "北京"
        }, {
            "value": "80603",
            "name": "天津"
        }, {
            "value": "205741",
            "name": "河北"
        }, {
            "value": "69509",
            "name": "山西"
        }, {
            "value": "1354251",
            "name": "河南"
        }, {
            "value": "196922",
            "name": "山东"
        }, {
            "value": "141661",
            "name": "上海"
        }, {
            "value": "376473",
            "name": "江苏"
        }, {
            "value": "576052",
            "name": "浙江"
        }, {
            "value": "668383",
            "name": "福建"
        }, {
            "value": "574772",
            "name": "安徽"
        }, {
            "value": "1117449",
            "name": "江西"
        }, {
            "value": "-1",
            "name": "湖北"
        }, {
            "value": "3211169",
            "name": "湖南"
        }, {
            "value": "2941982",
            "name": "广东"
        }, {
            "value": "448223",
            "name": "广西"
        }, {
            "value": "624303",
            "name": "贵州"
        }, {
            "value": "239787",
            "name": "云南"
        }, {
            "value": "50850",
            "name": "海南"
        }, {
            "value": "5275",
            "name": "黑龙江"
        }, {
            "value": "15560",
            "name": "吉林"
        }, {
            "value": "46187",
            "name": "辽宁"
        }, {
            "value": "732672",
            "name": "陕西"
        }, {
            "value": "121958",
            "name": "新疆"
        }, {
            "value": "39071",
            "name": "内蒙古"
        }, {
            "value": "37063",
            "name": "青海"
        }, {
            "value": "123277",
            "name": "宁夏"
        }, {
            "value": "253967",
            "name": "甘肃"
        }, {
            "value": "18045",
            "name": "西藏"
        }, {
            "value": "451446",
            "name": "四川"
        }, {
            "value": "773349",
            "name": "重庆"
        }],
        "nameName": "湖北",
        "toatl": "15539116"
    }, {
        "item": [{
            "value": "21713",
            "name": "北京"
        }, {
            "value": "54352",
            "name": "天津"
        }, {
            "value": "108003",
            "name": "河北"
        }, {
            "value": "18822",
            "name": "山西"
        }, {
            "value": "198044",
            "name": "河南"
        }, {
            "value": "80218",
            "name": "山东"
        }, {
            "value": "46635",
            "name": "上海"
        }, {
            "value": "131490",
            "name": "江苏"
        }, {
            "value": "197066",
            "name": "浙江"
        }, {
            "value": "101144",
            "name": "福建"
        }, {
            "value": "129194",
            "name": "安徽"
        }, {
            "value": "702199",
            "name": "江西"
        }, {
            "value": "681788",
            "name": "湖北"
        }, {
            "value": "-1",
            "name": "湖南"
        }, {
            "value": "3016411",
            "name": "广东"
        }, {
            "value": "492041",
            "name": "广西"
        }, {
            "value": "601505",
            "name": "贵州"
        }, {
            "value": "122605",
            "name": "云南"
        }, {
            "value": "31823",
            "name": "海南"
        }, {
            "value": "9803",
            "name": "黑龙江"
        }, {
            "value": "14970",
            "name": "吉林"
        }, {
            "value": "42554",
            "name": "辽宁"
        }, {
            "value": "57664",
            "name": "陕西"
        }, {
            "value": "12544",
            "name": "新疆"
        }, {
            "value": "5960",
            "name": "内蒙古"
        }, {
            "value": "2270",
            "name": "青海"
        }, {
            "value": "10896",
            "name": "宁夏"
        }, {
            "value": "17771",
            "name": "甘肃"
        }, {
            "value": "2029",
            "name": "西藏"
        }, {
            "value": "75953",
            "name": "四川"
        }, {
            "value": "205011",
            "name": "重庆"
        }],
        "nameName": "湖南",
        "toatl": "7192477"
    }, {
        "item": [{
            "value": "76260",
            "name": "北京"
        }, {
            "value": "95884",
            "name": "天津"
        }, {
            "value": "246962",
            "name": "河北"
        }, {
            "value": "28507",
            "name": "山西"
        }, {
            "value": "550553",
            "name": "河南"
        }, {
            "value": "157938",
            "name": "山东"
        }, {
            "value": "227146",
            "name": "上海"
        }, {
            "value": "385118",
            "name": "江苏"
        }, {
            "value": "648521",
            "name": "浙江"
        }, {
            "value": "626389",
            "name": "福建"
        }, {
            "value": "378917",
            "name": "安徽"
        }, {
            "value": "1214854",
            "name": "江西"
        }, {
            "value": "669756",
            "name": "湖北"
        }, {
            "value": "1488046",
            "name": "湖南"
        }, {
            "value": "-1",
            "name": "广东"
        }, {
            "value": "1393341",
            "name": "广西"
        }, {
            "value": "264904",
            "name": "贵州"
        }, {
            "value": "160824",
            "name": "云南"
        }, {
            "value": "129010",
            "name": "海南"
        }, {
            "value": "4754",
            "name": "黑龙江"
        }, {
            "value": "8864",
            "name": "吉林"
        }, {
            "value": "56817",
            "name": "辽宁"
        }, {
            "value": "119361",
            "name": "陕西"
        }, {
            "value": "33718",
            "name": "新疆"
        }, {
            "value": "8428",
            "name": "内蒙古"
        }, {
            "value": "2187",
            "name": "青海"
        }, {
            "value": "24265",
            "name": "宁夏"
        }, {
            "value": "55400",
            "name": "甘肃"
        }, {
            "value": "893",
            "name": "西藏"
        }, {
            "value": "263970",
            "name": "四川"
        }, {
            "value": "727866",
            "name": "重庆"
        }],
        "nameName": "广东",
        "toatl": "10049452"
    }, {
        "item": [{
            "value": "13514",
            "name": "北京"
        }, {
            "value": "10255",
            "name": "天津"
        }, {
            "value": "38278",
            "name": "河北"
        }, {
            "value": "6247",
            "name": "山西"
        }, {
            "value": "115092",
            "name": "河南"
        }, {
            "value": "70008",
            "name": "山东"
        }, {
            "value": "15531",
            "name": "上海"
        }, {
            "value": "38026",
            "name": "江苏"
        }, {
            "value": "74980",
            "name": "浙江"
        }, {
            "value": "99544",
            "name": "福建"
        }, {
            "value": "35084",
            "name": "安徽"
        }, {
            "value": "116524",
            "name": "江西"
        }, {
            "value": "137613",
            "name": "湖北"
        }, {
            "value": "644756",
            "name": "湖南"
        }, {
            "value": "6377368",
            "name": "广东"
        }, {
            "value": "-1",
            "name": "广西"
        }, {
            "value": "637878",
            "name": "贵州"
        }, {
            "value": "712045",
            "name": "云南"
        }, {
            "value": "149075",
            "name": "海南"
        }, {
            "value": "545",
            "name": "黑龙江"
        }, {
            "value": "1187",
            "name": "吉林"
        }, {
            "value": "2595",
            "name": "辽宁"
        }, {
            "value": "44243",
            "name": "陕西"
        }, {
            "value": "11036",
            "name": "新疆"
        }, {
            "value": "1515",
            "name": "内蒙古"
        }, {
            "value": "2787",
            "name": "青海"
        }, {
            "value": "3239",
            "name": "宁夏"
        }, {
            "value": "12482",
            "name": "甘肃"
        }, {
            "value": "1915",
            "name": "西藏"
        }, {
            "value": "91143",
            "name": "四川"
        }, {
            "value": "107538",
            "name": "重庆"
        }],
        "nameName": "广西",
        "toatl": "9572042"
    }, {
        "item": [{
            "value": "1947",
            "name": "北京"
        }, {
            "value": "1341",
            "name": "天津"
        }, {
            "value": "6668",
            "name": "河北"
        }, {
            "value": "5693",
            "name": "山西"
        }, {
            "value": "13259",
            "name": "河南"
        }, {
            "value": "5455",
            "name": "山东"
        }, {
            "value": "3154",
            "name": "上海"
        }, {
            "value": "3268",
            "name": "江苏"
        }, {
            "value": "13091",
            "name": "浙江"
        }, {
            "value": "7587",
            "name": "福建"
        }, {
            "value": "3755",
            "name": "安徽"
        }, {
            "value": "12990",
            "name": "江西"
        }, {
            "value": "14788",
            "name": "湖北"
        }, {
            "value": "77930",
            "name": "湖南"
        }, {
            "value": "62766",
            "name": "广东"
        }, {
            "value": "124424",
            "name": "广西"
        }, {
            "value": "-1",
            "name": "贵州"
        }, {
            "value": "156417",
            "name": "云南"
        }, {
            "value": "774",
            "name": "海南"
        }, {
            "value": "213",
            "name": "黑龙江"
        }, {
            "value": "979",
            "name": "吉林"
        }, {
            "value": "972",
            "name": "辽宁"
        }, {
            "value": "4614",
            "name": "陕西"
        }, {
            "value": "1231",
            "name": "新疆"
        }, {
            "value": "604",
            "name": "内蒙古"
        }, {
            "value": "726",
            "name": "青海"
        }, {
            "value": "169",
            "name": "宁夏"
        }, {
            "value": "2308",
            "name": "甘肃"
        }, {
            "value": "626",
            "name": "西藏"
        }, {
            "value": "46901",
            "name": "四川"
        }, {
            "value": "85932",
            "name": "重庆"
        }],
        "nameName": "贵州",
        "toatl": "660581"
    }, {
        "item": [{
            "value": "4816",
            "name": "北京"
        }, {
            "value": "12941",
            "name": "天津"
        }, {
            "value": "30752",
            "name": "河北"
        }, {
            "value": "6300",
            "name": "山西"
        }, {
            "value": "36955",
            "name": "河南"
        }, {
            "value": "8299",
            "name": "山东"
        }, {
            "value": "3634",
            "name": "上海"
        }, {
            "value": "10318",
            "name": "江苏"
        }, {
            "value": "9605",
            "name": "浙江"
        }, {
            "value": "5246",
            "name": "福建"
        }, {
            "value": "11084",
            "name": "安徽"
        }, {
            "value": "14137",
            "name": "江西"
        }, {
            "value": "22093",
            "name": "湖北"
        }, {
            "value": "40599",
            "name": "湖南"
        }, {
            "value": "109204",
            "name": "广东"
        }, {
            "value": "314531",
            "name": "广西"
        }, {
            "value": "526749",
            "name": "贵州"
        }, {
            "value": "-1",
            "name": "云南"
        }, {
            "value": "3117",
            "name": "海南"
        }, {
            "value": "2265",
            "name": "黑龙江"
        }, {
            "value": "4971",
            "name": "吉林"
        }, {
            "value": "13287",
            "name": "辽宁"
        }, {
            "value": "25735",
            "name": "陕西"
        }, {
            "value": "3171",
            "name": "新疆"
        }, {
            "value": "5440",
            "name": "内蒙古"
        }, {
            "value": "1715",
            "name": "青海"
        }, {
            "value": "1071",
            "name": "宁夏"
        }, {
            "value": "8714",
            "name": "甘肃"
        }, {
            "value": "15870",
            "name": "西藏"
        }, {
            "value": "270621",
            "name": "四川"
        }, {
            "value": "28480",
            "name": "重庆"
        }],
        "nameName": "云南",
        "toatl": "1551719"
    }, {
        "item": [{
            "value": "126",
            "name": "北京"
        }, {
            "value": "105",
            "name": "天津"
        }, {
            "value": "452",
            "name": "河北"
        }, {
            "value": "95",
            "name": "山西"
        }, {
            "value": "747",
            "name": "河南"
        }, {
            "value": "1923",
            "name": "山东"
        }, {
            "value": "1216",
            "name": "上海"
        }, {
            "value": "887",
            "name": "江苏"
        }, {
            "value": "1516",
            "name": "浙江"
        }, {
            "value": "2273",
            "name": "福建"
        }, {
            "value": "1100",
            "name": "安徽"
        }, {
            "value": "3522",
            "name": "江西"
        }, {
            "value": "1487",
            "name": "湖北"
        }, {
            "value": "2341",
            "name": "湖南"
        }, {
            "value": "108547",
            "name": "广东"
        }, {
            "value": "8475",
            "name": "广西"
        }, {
            "value": "703",
            "name": "贵州"
        }, {
            "value": "49",
            "name": "云南"
        }, {
            "value": "-1",
            "name": "海南"
        }, {
            "value": "70",
            "name": "黑龙江"
        }, {
            "value": "64",
            "name": "吉林"
        }, {
            "value": "40",
            "name": "辽宁"
        }, {
            "value": "1107",
            "name": "陕西"
        }, {
            "value": "304",
            "name": "新疆"
        }, {
            "value": "352",
            "name": "内蒙古"
        }, {
            "value": "11",
            "name": "青海"
        }, {
            "value": "38",
            "name": "宁夏"
        }, {
            "value": "150",
            "name": "甘肃"
        }, {
            "value": "140",
            "name": "西藏"
        }, {
            "value": "720",
            "name": "四川"
        }, {
            "value": "368",
            "name": "重庆"
        }],
        "nameName": "海南",
        "toatl": "138927"
    }, {
        "item": [{
            "value": "242555",
            "name": "北京"
        }, {
            "value": "1346135",
            "name": "天津"
        }, {
            "value": "2669765",
            "name": "河北"
        }, {
            "value": "257023",
            "name": "山西"
        }, {
            "value": "856238",
            "name": "河南"
        }, {
            "value": "1986010",
            "name": "山东"
        }, {
            "value": "84036",
            "name": "上海"
        }, {
            "value": "606981",
            "name": "江苏"
        }, {
            "value": "231719",
            "name": "浙江"
        }, {
            "value": "50321",
            "name": "福建"
        }, {
            "value": "228862",
            "name": "安徽"
        }, {
            "value": "131960",
            "name": "江西"
        }, {
            "value": "297084",
            "name": "湖北"
        }, {
            "value": "269499",
            "name": "湖南"
        }, {
            "value": "229349",
            "name": "广东"
        }, {
            "value": "85029",
            "name": "广西"
        }, {
            "value": "65905",
            "name": "贵州"
        }, {
            "value": "75951",
            "name": "云南"
        }, {
            "value": "25601",
            "name": "海南"
        }, {
            "value": "-1",
            "name": "黑龙江"
        }, {
            "value": "3356344",
            "name": "吉林"
        }, {
            "value": "3699476",
            "name": "辽宁"
        }, {
            "value": "247143",
            "name": "陕西"
        }, {
            "value": "227511",
            "name": "新疆"
        }, {
            "value": "2247852",
            "name": "内蒙古"
        }, {
            "value": "55960",
            "name": "青海"
        }, {
            "value": "60721",
            "name": "宁夏"
        }, {
            "value": "128666",
            "name": "甘肃"
        }, {
            "value": "19807",
            "name": "西藏"
        }, {
            "value": "113535",
            "name": "四川"
        }, {
            "value": "55730",
            "name": "重庆"
        }],
        "nameName": "黑龙江",
        "toatl": "19952767"
    }, {
        "item": [{
            "value": "357026",
            "name": "北京"
        }, {
            "value": "1172949",
            "name": "天津"
        }, {
            "value": "2303243",
            "name": "河北"
        }, {
            "value": "204097",
            "name": "山西"
        }, {
            "value": "951626",
            "name": "河南"
        }, {
            "value": "1302102",
            "name": "山东"
        }, {
            "value": "131154",
            "name": "上海"
        }, {
            "value": "614511",
            "name": "江苏"
        }, {
            "value": "293500",
            "name": "浙江"
        }, {
            "value": "79489",
            "name": "福建"
        }, {
            "value": "246371",
            "name": "安徽"
        }, {
            "value": "208109",
            "name": "江西"
        }, {
            "value": "371124",
            "name": "湖北"
        }, {
            "value": "337779",
            "name": "湖南"
        }, {
            "value": "422927",
            "name": "广东"
        }, {
            "value": "101056",
            "name": "广西"
        }, {
            "value": "87751",
            "name": "贵州"
        }, {
            "value": "76790",
            "name": "云南"
        }, {
            "value": "16015",
            "name": "海南"
        }, {
            "value": "734505",
            "name": "黑龙江"
        }, {
            "value": "-1",
            "name": "吉林"
        }, {
            "value": "3214952",
            "name": "辽宁"
        }, {
            "value": "539203",
            "name": "陕西"
        }, {
            "value": "174732",
            "name": "新疆"
        }, {
            "value": "1201147",
            "name": "内蒙古"
        }, {
            "value": "37237",
            "name": "青海"
        }, {
            "value": "75905",
            "name": "宁夏"
        }, {
            "value": "151663",
            "name": "甘肃"
        }, {
            "value": "9556",
            "name": "西藏"
        }, {
            "value": "355724",
            "name": "四川"
        }, {
            "value": "159170",
            "name": "重庆"
        }],
        "nameName": "吉林",
        "toatl": "15931412"
    }, {
        "item": [{
            "value": "1030103",
            "name": "北京"
        }, {
            "value": "3905785",
            "name": "天津"
        }, {
            "value": "8810585",
            "name": "河北"
        }, {
            "value": "799356",
            "name": "山西"
        }, {
            "value": "2112358",
            "name": "河南"
        }, {
            "value": "3442040",
            "name": "山东"
        }, {
            "value": "303645",
            "name": "上海"
        }, {
            "value": "1857162",
            "name": "江苏"
        }, {
            "value": "659871",
            "name": "浙江"
        }, {
            "value": "219593",
            "name": "福建"
        }, {
            "value": "584922",
            "name": "安徽"
        }, {
            "value": "399407",
            "name": "江西"
        }, {
            "value": "868290",
            "name": "湖北"
        }, {
            "value": "731753",
            "name": "湖南"
        }, {
            "value": "603641",
            "name": "广东"
        }, {
            "value": "265425",
            "name": "广西"
        }, {
            "value": "253360",
            "name": "贵州"
        }, {
            "value": "258476",
            "name": "云南"
        }, {
            "value": "55972",
            "name": "海南"
        }, {
            "value": "1749709",
            "name": "黑龙江"
        }, {
            "value": "4183043",
            "name": "吉林"
        }, {
            "value": "-1",
            "name": "辽宁"
        }, {
            "value": "796018",
            "name": "陕西"
        }, {
            "value": "398973",
            "name": "新疆"
        }, {
            "value": "3756300",
            "name": "内蒙古"
        }, {
            "value": "77646",
            "name": "青海"
        }, {
            "value": "172209",
            "name": "宁夏"
        }, {
            "value": "316593",
            "name": "甘肃"
        }, {
            "value": "17949",
            "name": "西藏"
        }, {
            "value": "434077",
            "name": "四川"
        }, {
            "value": "205992",
            "name": "重庆"
        }],
        "nameName": "辽宁",
        "toatl": "39270252"
    }, {
        "item": [{
            "value": "20924",
            "name": "北京"
        }, {
            "value": "28724",
            "name": "天津"
        }, {
            "value": "106419",
            "name": "河北"
        }, {
            "value": "1536722",
            "name": "山西"
        }, {
            "value": "563677",
            "name": "河南"
        }, {
            "value": "83091",
            "name": "山东"
        }, {
            "value": "15087",
            "name": "上海"
        }, {
            "value": "65716",
            "name": "江苏"
        }, {
            "value": "56093",
            "name": "浙江"
        }, {
            "value": "48543",
            "name": "福建"
        }, {
            "value": "86734",
            "name": "安徽"
        }, {
            "value": "104979",
            "name": "江西"
        }, {
            "value": "795099",
            "name": "湖北"
        }, {
            "value": "503579",
            "name": "湖南"
        }, {
            "value": "355133",
            "name": "广东"
        }, {
            "value": "105074",
            "name": "广西"
        }, {
            "value": "198950",
            "name": "贵州"
        }, {
            "value": "249842",
            "name": "云南"
        }, {
            "value": "13728",
            "name": "海南"
        }, {
            "value": "4091",
            "name": "黑龙江"
        }, {
            "value": "4117",
            "name": "吉林"
        }, {
            "value": "12425",
            "name": "辽宁"
        }, {
            "value": "-1",
            "name": "陕西"
        }, {
            "value": "273560",
            "name": "新疆"
        }, {
            "value": "1151447",
            "name": "内蒙古"
        }, {
            "value": "187743",
            "name": "青海"
        }, {
            "value": "1102159",
            "name": "宁夏"
        }, {
            "value": "1738149",
            "name": "甘肃"
        }, {
            "value": "37607",
            "name": "西藏"
        }, {
            "value": "2011150",
            "name": "四川"
        }, {
            "value": "475250",
            "name": "重庆"
        }],
        "nameName": "陕西",
        "toatl": "11935811"
    }, {
        "item": [{
            "value": "1639",
            "name": "北京"
        }, {
            "value": "2408",
            "name": "天津"
        }, {
            "value": "7106",
            "name": "河北"
        }, {
            "value": "4925",
            "name": "山西"
        }, {
            "value": "12006",
            "name": "河南"
        }, {
            "value": "6157",
            "name": "山东"
        }, {
            "value": "1175",
            "name": "上海"
        }, {
            "value": "3829",
            "name": "江苏"
        }, {
            "value": "2418",
            "name": "浙江"
        }, {
            "value": "753",
            "name": "福建"
        }, {
            "value": "4417",
            "name": "安徽"
        }, {
            "value": "1513",
            "name": "江西"
        }, {
            "value": "5940",
            "name": "湖北"
        }, {
            "value": "5738",
            "name": "湖南"
        }, {
            "value": "5700",
            "name": "广东"
        }, {
            "value": "719",
            "name": "广西"
        }, {
            "value": "1676",
            "name": "贵州"
        }, {
            "value": "590",
            "name": "云南"
        }, {
            "value": "9",
            "name": "海南"
        }, {
            "value": "449",
            "name": "黑龙江"
        }, {
            "value": "822",
            "name": "吉林"
        }, {
            "value": "457",
            "name": "辽宁"
        }, {
            "value": "17940",
            "name": "陕西"
        }, {
            "value": "-1",
            "name": "新疆"
        }, {
            "value": "8126",
            "name": "内蒙古"
        }, {
            "value": "33564",
            "name": "青海"
        }, {
            "value": "14981",
            "name": "宁夏"
        }, {
            "value": "123964",
            "name": "甘肃"
        }, {
            "value": "4870",
            "name": "西藏"
        }, {
            "value": "10343",
            "name": "四川"
        }, {
            "value": "2931",
            "name": "重庆"
        }],
        "nameName": "新疆",
        "toatl": "287164"
    }, {
        "item": [{
            "value": "440797",
            "name": "北京"
        }, {
            "value": "509421",
            "name": "天津"
        }, {
            "value": "1529409",
            "name": "河北"
        }, {
            "value": "440626",
            "name": "山西"
        }, {
            "value": "145210",
            "name": "河南"
        }, {
            "value": "327582",
            "name": "山东"
        }, {
            "value": "22744",
            "name": "上海"
        }, {
            "value": "114074",
            "name": "江苏"
        }, {
            "value": "33695",
            "name": "浙江"
        }, {
            "value": "6936",
            "name": "福建"
        }, {
            "value": "47625",
            "name": "安徽"
        }, {
            "value": "18424",
            "name": "江西"
        }, {
            "value": "69026",
            "name": "湖北"
        }, {
            "value": "45835",
            "name": "湖南"
        }, {
            "value": "32192",
            "name": "广东"
        }, {
            "value": "10916",
            "name": "广西"
        }, {
            "value": "10807",
            "name": "贵州"
        }, {
            "value": "16509",
            "name": "云南"
        }, {
            "value": "1475",
            "name": "海南"
        }, {
            "value": "129298",
            "name": "黑龙江"
        }, {
            "value": "186987",
            "name": "吉林"
        }, {
            "value": "565878",
            "name": "辽宁"
        }, {
            "value": "480101",
            "name": "陕西"
        }, {
            "value": "122425",
            "name": "新疆"
        }, {
            "value": "-1",
            "name": "内蒙古"
        }, {
            "value": "44595",
            "name": "青海"
        }, {
            "value": "470742",
            "name": "宁夏"
        }, {
            "value": "320019",
            "name": "甘肃"
        }, {
            "value": "8084",
            "name": "西藏"
        }, {
            "value": "86876",
            "name": "四川"
        }, {
            "value": "31769",
            "name": "重庆"
        }],
        "nameName": "内蒙古",
        "toatl": "6270076"
    }, {
        "item": [{
            "value": "516",
            "name": "北京"
        }, {
            "value": "226",
            "name": "天津"
        }, {
            "value": "1016",
            "name": "河北"
        }, {
            "value": "3026",
            "name": "山西"
        }, {
            "value": "5055",
            "name": "河南"
        }, {
            "value": "2621",
            "name": "山东"
        }, {
            "value": "293",
            "name": "上海"
        }, {
            "value": "2396",
            "name": "江苏"
        }, {
            "value": "1983",
            "name": "浙江"
        }, {
            "value": "50",
            "name": "福建"
        }, {
            "value": "2314",
            "name": "安徽"
        }, {
            "value": "2220",
            "name": "江西"
        }, {
            "value": "1553",
            "name": "湖北"
        }, {
            "value": "1302",
            "name": "湖南"
        }, {
            "value": "1544",
            "name": "广东"
        }, {
            "value": "748",
            "name": "广西"
        }, {
            "value": "1736",
            "name": "贵州"
        }, {
            "value": "4907",
            "name": "云南"
        }, {
            "value": "373",
            "name": "海南"
        }, {
            "value": "353",
            "name": "黑龙江"
        }, {
            "value": "8",
            "name": "吉林"
        }, {
            "value": "169",
            "name": "辽宁"
        }, {
            "value": "11504",
            "name": "陕西"
        }, {
            "value": "50638",
            "name": "新疆"
        }, {
            "value": "6031",
            "name": "内蒙古"
        }, {
            "value": "-1",
            "name": "青海"
        }, {
            "value": "9354",
            "name": "宁夏"
        }, {
            "value": "240409",
            "name": "甘肃"
        }, {
            "value": "203450",
            "name": "西藏"
        }, {
            "value": "61247",
            "name": "四川"
        }, {
            "value": "3757",
            "name": "重庆"
        }],
        "nameName": "青海",
        "toatl": "620798"
    }, {
        "item": [{
            "value": "30647",
            "name": "北京"
        }, {
            "value": "61271",
            "name": "天津"
        }, {
            "value": "99806",
            "name": "河北"
        }, {
            "value": "68476",
            "name": "山西"
        }, {
            "value": "279646",
            "name": "河南"
        }, {
            "value": "22423",
            "name": "山东"
        }, {
            "value": "14409",
            "name": "上海"
        }, {
            "value": "100402",
            "name": "江苏"
        }, {
            "value": "88759",
            "name": "浙江"
        }, {
            "value": "14456",
            "name": "福建"
        }, {
            "value": "220698",
            "name": "安徽"
        }, {
            "value": "31157",
            "name": "江西"
        }, {
            "value": "294459",
            "name": "湖北"
        }, {
            "value": "203936",
            "name": "湖南"
        }, {
            "value": "138658",
            "name": "广东"
        }, {
            "value": "30039",
            "name": "广西"
        }, {
            "value": "38370",
            "name": "贵州"
        }, {
            "value": "79834",
            "name": "云南"
        }, {
            "value": "2913",
            "name": "海南"
        }, {
            "value": "180",
            "name": "黑龙江"
        }, {
            "value": "951",
            "name": "吉林"
        }, {
            "value": "1175",
            "name": "辽宁"
        }, {
            "value": "1105023",
            "name": "陕西"
        }, {
            "value": "312038",
            "name": "新疆"
        }, {
            "value": "1293456",
            "name": "内蒙古"
        }, {
            "value": "265936",
            "name": "青海"
        }, {
            "value": "-1",
            "name": "宁夏"
        }, {
            "value": "1864044",
            "name": "甘肃"
        }, {
            "value": "67391",
            "name": "西藏"
        }, {
            "value": "347314",
            "name": "四川"
        }, {
            "value": "78442",
            "name": "重庆"
        }],
        "nameName": "宁夏",
        "toatl": "7156308"
    }, {
        "item": [{
            "value": "9509",
            "name": "北京"
        }, {
            "value": "7737",
            "name": "天津"
        }, {
            "value": "24441",
            "name": "河北"
        }, {
            "value": "19924",
            "name": "山西"
        }, {
            "value": "63492",
            "name": "河南"
        }, {
            "value": "9546",
            "name": "山东"
        }, {
            "value": "4039",
            "name": "上海"
        }, {
            "value": "19153",
            "name": "江苏"
        }, {
            "value": "15960",
            "name": "浙江"
        }, {
            "value": "6983",
            "name": "福建"
        }, {
            "value": "29042",
            "name": "安徽"
        }, {
            "value": "12163",
            "name": "江西"
        }, {
            "value": "72279",
            "name": "湖北"
        }, {
            "value": "64639",
            "name": "湖南"
        }, {
            "value": "56372",
            "name": "广东"
        }, {
            "value": "10402",
            "name": "广西"
        }, {
            "value": "23145",
            "name": "贵州"
        }, {
            "value": "29857",
            "name": "云南"
        }, {
            "value": "923",
            "name": "海南"
        }, {
            "value": "271",
            "name": "黑龙江"
        }, {
            "value": "239",
            "name": "吉林"
        }, {
            "value": "1458",
            "name": "辽宁"
        }, {
            "value": "647964",
            "name": "陕西"
        }, {
            "value": "326411",
            "name": "新疆"
        }, {
            "value": "180929",
            "name": "内蒙古"
        }, {
            "value": "339752",
            "name": "青海"
        }, {
            "value": "539740",
            "name": "宁夏"
        }, {
            "value": "-1",
            "name": "甘肃"
        }, {
            "value": "76544",
            "name": "西藏"
        }, {
            "value": "359153",
            "name": "四川"
        }, {
            "value": "56036",
            "name": "重庆"
        }],
        "nameName": "甘肃",
        "toatl": "3008102"
    }, {
        "item": [{
            "value": "22",
            "name": "北京"
        }, {
            "value": "0",
            "name": "天津"
        }, {
            "value": "23",
            "name": "河北"
        }, {
            "value": "26",
            "name": "山西"
        }, {
            "value": "129",
            "name": "河南"
        }, {
            "value": "28",
            "name": "山东"
        }, {
            "value": "0",
            "name": "上海"
        }, {
            "value": "0",
            "name": "江苏"
        }, {
            "value": "0",
            "name": "浙江"
        }, {
            "value": "0",
            "name": "福建"
        }, {
            "value": "0",
            "name": "安徽"
        }, {
            "value": "1",
            "name": "江西"
        }, {
            "value": "52",
            "name": "湖北"
        }, {
            "value": "0",
            "name": "湖南"
        }, {
            "value": "0",
            "name": "广东"
        }, {
            "value": "0",
            "name": "广西"
        }, {
            "value": "0",
            "name": "贵州"
        }, {
            "value": "245",
            "name": "云南"
        }, {
            "value": "0",
            "name": "海南"
        }, {
            "value": "0",
            "name": "黑龙江"
        }, {
            "value": "0",
            "name": "吉林"
        }, {
            "value": "0",
            "name": "辽宁"
        }, {
            "value": "49",
            "name": "陕西"
        }, {
            "value": "36",
            "name": "新疆"
        }, {
            "value": "0",
            "name": "内蒙古"
        }, {
            "value": "1748",
            "name": "青海"
        }, {
            "value": "21",
            "name": "宁夏"
        }, {
            "value": "57",
            "name": "甘肃"
        }, {
            "value": "-1",
            "name": "西藏"
        }, {
            "value": "890",
            "name": "四川"
        }, {
            "value": "1",
            "name": "重庆"
        }],
        "nameName": "西藏",
        "toatl": "3327"
    }, {
        "item": [{
            "value": "16366",
            "name": "北京"
        }, {
            "value": "25588",
            "name": "天津"
        }, {
            "value": "72097",
            "name": "河北"
        }, {
            "value": "29176",
            "name": "山西"
        }, {
            "value": "132179",
            "name": "河南"
        }, {
            "value": "29965",
            "name": "山东"
        }, {
            "value": "37184",
            "name": "上海"
        }, {
            "value": "85623",
            "name": "江苏"
        }, {
            "value": "99570",
            "name": "浙江"
        }, {
            "value": "159919",
            "name": "福建"
        }, {
            "value": "91464",
            "name": "安徽"
        }, {
            "value": "115047",
            "name": "江西"
        }, {
            "value": "279143",
            "name": "湖北"
        }, {
            "value": "342108",
            "name": "湖南"
        }, {
            "value": "585704",
            "name": "广东"
        }, {
            "value": "383827",
            "name": "广西"
        }, {
            "value": "1536851",
            "name": "贵州"
        }, {
            "value": "1947368",
            "name": "云南"
        }, {
            "value": "17591",
            "name": "海南"
        }, {
            "value": "4423",
            "name": "黑龙江"
        }, {
            "value": "8711",
            "name": "吉林"
        }, {
            "value": "20518",
            "name": "辽宁"
        }, {
            "value": "436060",
            "name": "陕西"
        }, {
            "value": "191923",
            "name": "新疆"
        }, {
            "value": "16245",
            "name": "内蒙古"
        }, {
            "value": "107888",
            "name": "青海"
        }, {
            "value": "17980",
            "name": "宁夏"
        }, {
            "value": "177564",
            "name": "甘肃"
        }, {
            "value": "231917",
            "name": "西藏"
        }, {
            "value": "-1",
            "name": "四川"
        }, {
            "value": "3195289",
            "name": "重庆"
        }],
        "nameName": "四川",
        "toatl": "10395287"
    }, {
        "item": [{
            "value": "28275",
            "name": "北京"
        }, {
            "value": "64961",
            "name": "天津"
        }, {
            "value": "121686",
            "name": "河北"
        }, {
            "value": "63824",
            "name": "山西"
        }, {
            "value": "195108",
            "name": "河南"
        }, {
            "value": "82629",
            "name": "山东"
        }, {
            "value": "96605",
            "name": "上海"
        }, {
            "value": "174150",
            "name": "江苏"
        }, {
            "value": "243149",
            "name": "浙江"
        }, {
            "value": "413183",
            "name": "福建"
        }, {
            "value": "164593",
            "name": "安徽"
        }, {
            "value": "280941",
            "name": "江西"
        }, {
            "value": "884705",
            "name": "湖北"
        }, {
            "value": "1330000",
            "name": "湖南"
        }, {
            "value": "1095321",
            "name": "广东"
        }, {
            "value": "505067",
            "name": "广西"
        }, {
            "value": "4410101",
            "name": "贵州"
        }, {
            "value": "1295977",
            "name": "云南"
        }, {
            "value": "29562",
            "name": "海南"
        }, {
            "value": "5347",
            "name": "黑龙江"
        }, {
            "value": "11380",
            "name": "吉林"
        }, {
            "value": "20562",
            "name": "辽宁"
        }, {
            "value": "250255",
            "name": "陕西"
        }, {
            "value": "263853",
            "name": "新疆"
        }, {
            "value": "20200",
            "name": "内蒙古"
        }, {
            "value": "32336",
            "name": "青海"
        }, {
            "value": "15484",
            "name": "宁夏"
        }, {
            "value": "82821",
            "name": "甘肃"
        }, {
            "value": "53582",
            "name": "西藏"
        }, {
            "value": "4868921",
            "name": "四川"
        }, {
            "value": "-1",
            "name": "重庆"
        }],
        "nameName": "重庆",
        "toatl": "17104577"
    }]
}